// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__2tqvC","author":"Table_author__1Ih6S","authorImage":"Table_authorImage__1EoDG","unreadRow":"Table_unreadRow__2uHGD"};